import JobStatus from "@/models/Jobs/JobStatus";

export default (value: JobStatus) => {
    switch (value) {
        case JobStatus.Open:
            return "Open";
        case JobStatus.Closed:
            return "Closed";
        default:
            return "Unknown";
    }
} 